import { useDoBoxExecutorFlags } from './useDoBoxExecutorFlags';
import { useDetailedInboxEntry } from '../../services/inboxEntries.service';
import { useFloatingAssistantStore } from '../../store/FloatingAssistant';
import { useIsEntryOwner } from '../InboxEntries/useIsEntryOwner';

export function useCanUseDoBoxReplyPanel(entryId?: string): boolean {
  const { flags } = useDoBoxExecutorFlags();
  const { entry } = useDetailedInboxEntry(entryId ?? '', {
    skip: !entryId,
  });
  const isHostedForEntry = useFloatingAssistantStore(
    (state) =>
      entryId !== undefined &&
      state.hostContext?.kind === 'dobox' &&
      state.hostContext.itemId === entryId,
  );
  const isOwnerViewer = useIsEntryOwner(entry);

  return flags.executor && isHostedForEntry && isOwnerViewer;
}
